import { Tag as AntdTag, TagProps as AntdTagProps } from "antd";
import { CMP_PREFIX } from "@/base/constant";

export interface TagProps extends AntdTagProps {}

export const tagPrefixCls = `${CMP_PREFIX}-tag`;

export const Tag = ({ ...props }: TagProps) => {
  return <AntdTag {...props} />;
};
